import { atom } from "recoil";

export type StampCouponModalType = {
  visibleConfirm: boolean;
  handleConfirm?: any;
  modalData: any;
};

export const stampCouponModalState = atom<StampCouponModalType>({
  key: "stampCouponModal",
  default: {
    visibleConfirm: false,
    modalData: [],
  },
});
